/**
 *  IP 信息
 */
let baseUrl, imageUrl, origin, socketUrl;

// const devUrl = '/new';
const devUrl = 'http://217.79.252.98:39966';

switch (process.env.NODE_ENV) {
  case "development":
    origin = '/';
    baseUrl = devUrl + "/eternalx-labs";
    imageUrl = devUrl + "/eternalx-labs/";

    // baseUrl = "https://login.coternalx.com/eternalx-labs";
    // imageUrl = "https://login.coternalx.com/eternalx-labs/";
    socketUrl = ''

    break;
  case "production":
    origin = 'https://login.coternalx.com/';
    baseUrl = "https://login.coternalx.com/eternalx-labs";
    imageUrl = "https://login.coternalx.com/eternalx-labs/";
    // socketUrl = 'ws://181.41.141.34:21301/ez'

    break;
}

export { baseUrl, imageUrl, origin, socketUrl };
